import { render, staticRenderFns } from "./BusinessOrder.vue?vue&type=template&id=997a0850&scoped=true&"
import script from "./BusinessOrder.vue?vue&type=script&lang=js&"
export * from "./BusinessOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997a0850",
  null
  
)

export default component.exports